<script setup lang="ts">
import ModalHowToPlay from '~/components/pages/results/modals/ModalHowToPlay.vue'
import { trackRulesOpen } from '~/tracking/resultEvents'

defineOptions({
	name: 'InfoPlayLottery',
})

interface Lottery {
	id: number
	label: string
	classExtraBtn?: string
	containerBtn?: string
}

const props = defineProps({
	lottery: {
		type: Object as PropType<Lottery>,
		default: () => ({ id: 0, label: '' }),
	},
	classExtraBtn: {
		type: String,
		default: '',
	},
	containerBtn: {
		type: String,
		default: '',
	},
})

const showModalHowToPlay = ref<boolean>(false)

const openModal = () => {
	showModalHowToPlay.value = true
	trackRulesOpen({
		lottery_id: props.lottery?.id ?? 0,
		game_name: props.lottery?.label ?? '',
	})
}
</script>

<template>
	<div>
		<div
			class="flex items-center"
			:class="props.containerBtn"
			@click.stop="openModal"
		>
			<slot name="icon">
				<UIcon
					name="i-material-symbols:info-outline-rounded"
					class="text-neutral-600 hover:text-neutral-50 transition-all duration-300 size-5 hover:cursor-pointer"
					:class="props.classExtraBtn"
				/>
			</slot>
		</div>
		<ModalHowToPlay
			v-model="showModalHowToPlay"
			:id-lottery="props.lottery?.id"
		/>
	</div>
</template>
